/**
 * @copyright       Palace Resorts
 * @description     Mensajes para modal de registro terminos y contratos
 * @author          Leticia Beltran
 * @creationDate    
 */

 import _ from "lodash";
 import appMessages from "@/i18n/app.messages";
 
 let moduleMessages = {
     messages: {
         ESP: {
             lblTitle: "Subcontratación",
             lblTitleModal: "Términos y condiciones",
             lblsubtitle: "Términos y condiciones",
             lblID: "ID",
             lblProvider: "Proveedor",
             lblCompany: "Sociedad",
             lblOrder: "Pedido",
             lblDateStart: "Fecha de vigencia inicio",
             lblDateEnd: "Fecha de vigencia fin",
             lblCheck: "Activar check si se desea cambiar el archivo",
             lblFile: "Archivo",
             lblChooseProvider: "Elegir proveedor",
         },
         ENG: {
             lblTitle: "Outsourcing",
             lblsubtitle: "Terms and conditions",
             lblTitleModal: "Terms and conditions",
             lblID: "ID",
             lblProvider: "Provider",
             lblCompany: "Company",
             lblOrder: "Order",
             lblDateStart: "Date start",
             lblDateEnd: "Date end",
             lblCheck: "Activate check if you want to change the file",
             lblFile: "File",
             lblChooseProvider: "Choose provider",
         },
     },
 };
 
 export default _.merge(moduleMessages, appMessages);